var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"het-dal"},[_c('AudioPlayer',{staticClass:"audio-player",attrs:{"src":require('@/assets/audio/helene_gedicht.mp3'),"title":"Luister naar Helene","trackTitle":"gedicht-helene"}}),_vm._v(" "),_vm._l((_vm.paragraphs),function(paragraph,index){return _c('DalParagraph',{key:index,attrs:{"p":paragraph}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-764a7b06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dal/HetDal.vue
// module id = null
// module chunks = 